//console.log("loaded");

$("#productSelector").change(event => {
  const selectedOption = event.target.selectedOptions[0];
  const priceString = `${selectedOption.dataset.price / 100} €`;

  $(".product-header_price").html(priceString);
});
